export const BUILD_VERSION = '1774539649';
